const resources = {
  "en": {
    "balanceHistory": {
      "title": "Balance history",
      "description": "Review net balance movement over time. Active debts reduce the charted balance; archived debts stay historical and are excluded from current obligations.",
      "meta": "Historical balance view",
      "valuation": {
        "estimatedTitle": "Balance history uses explicit valuation",
        "estimatedDescription": "Historical balances are valued in {{currency}} from native account balances and current FX quotes.",
        "staleTitle": "Balance history uses stale FX quotes",
        "staleDescription": "Historical balances are valued in {{currency}}, but some FX quotes are stale. Totals may lag until quotes refresh.",
        "degradedTitle": "Balance history is partially degraded",
        "degradedDescription": "Historical balances are valued in {{currency}}, but some FX quotes are missing or failed. Totals may be incomplete until refresh succeeds.",
        "partialTitle": "Balance history has partial valuation coverage",
        "partialDescription": "Historical balances are valued in {{currency}}, but some accounts cannot be valued with the current quote set. Totals reflect only the valuated subset."
      },
      "units": {
        "day": "Daily",
        "week": "Weekly",
        "month": "Monthly"
      },
      "filters": {
        "all": "All values",
        "positive": "Positive balances",
        "negative": "Negative balances",
        "empty": "No data for the selected filter",
        "summary": "{{unit}} view for {{range}}"
      },
      "primaryChart": {
        "title": "Net balance movement",
        "description": "See how cash balance changes after active debts are considered."
      },
      "secondaryChart": {
        "title": "Trend view",
        "description": "Inspect the same period with filter and trend controls."
      },
      "trendToggle": "Show trend",
      "empty": "No balance history available yet.",
      "privacyHidden": "Amounts hidden",
      "errors": {
        "load": "Failed to load balance history"
      }
    }
  },
  "uk": {
    "balanceHistory": {
      "title": "Історія балансу",
      "description": "Переглядай рух net balance у часі. Активні борги зменшують баланс на графіку; архівні борги залишаються історією і не входять у поточні зобовʼязання.",
      "meta": "Історичний перегляд балансу",
      "valuation": {
        "estimatedTitle": "Історія балансу використовує explicit valuation",
        "estimatedDescription": "Історичні баланси оцінюються в {{currency}} з native account balances і поточних FX-курсів.",
        "staleTitle": "Історія балансу використовує застарілі FX-курси",
        "staleDescription": "Історичні баланси оцінюються в {{currency}}, але частина FX-курсів застаріла. Підсумки можуть оновитися після refresh.",
        "degradedTitle": "Історія балансу частково деградована",
        "degradedDescription": "Історичні баланси оцінюються в {{currency}}, але частина FX-курсів відсутня або завершилася помилкою. Підсумки можуть бути неповними до успішного refresh.",
        "partialTitle": "Для історії балансу є лише часткове valuation coverage",
        "partialDescription": "Історичні баланси оцінюються в {{currency}}, але частину рахунків не можна оцінити з поточним набором котирувань. Підсумки відображають лише оцінену частину."
      },
      "units": {
        "day": "Щодня",
        "week": "Щотижня",
        "month": "Щомісяця"
      },
      "filters": {
        "all": "Усі значення",
        "positive": "Позитивні значення",
        "negative": "Негативні значення",
        "empty": "Немає даних для вибраного фільтра",
        "summary": "{{unit}} перегляд за {{range}}"
      },
      "primaryChart": {
        "title": "Рух net balance",
        "description": "Подивись, як змінювався cash balance з урахуванням активних боргів."
      },
      "secondaryChart": {
        "title": "Трендовий перегляд",
        "description": "Переглядай той самий період з фільтром і трендовою лінією."
      },
      "trendToggle": "Показати тренд",
      "empty": "Немає даних історії балансу.",
      "privacyHidden": "Суми приховані",
      "errors": {
        "load": "Не вдалося завантажити історію балансу"
      }
    }
  }
};

export default resources;
